import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Chip, IconButton, ListItem, ListItemText } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import DeleteIcon from "@mui/icons-material/Delete";

export default function SortableRow({ id, index, name, onRemove, isChanged }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        background: isChanged ? "#FFF8E1" : "#fff",
        cursor: isDragging ? "grabbing" : "grab",
    };

    return (
        <ListItem
            ref={setNodeRef}
            style={style}
            divider
            secondaryAction={
                <IconButton edge="end" size="small" onClick={() => onRemove(id)} color="error">
                    <DeleteIcon fontSize="small" />
                </IconButton>
            }
            {...attributes}
            {...listeners}
        >
            <DragIndicatorIcon fontSize="small" sx={{ mr: 1, color: "action.active" }} />
            <Chip label={index} size="small" sx={{ mr: 2, minWidth: 32 }} />
            <ListItemText primary={name} secondary={`#${id}`} />
        </ListItem>
    );
}
